<template>
  <div class="list-group m-0">
    <div class="list-group-item">
      <nav>
        <div class="nav nav-tabs" id="nav-opciones" role="tablist">
          <a class="nav-link active" id="nav-config-tab" data-toggle="tab" href="#nav-config" role="tab" aria-controls="nav-config" aria-selected="true">Configuración</a>
          <a class="nav-link" id="nav-redes-tab" data-toggle="tab" href="#nav-redes" role="tab" aria-controls="nav-redes" aria-selected="false" v-if="reg != '' && form.bazar == 1">Redes sociales</a>
        </div>
      </nav>
      <div class="tab-content" id="nav-contenidos">
        <div class="tab-pane fade show active" id="nav-config" role="tabpanel" aria-labelledby="nav-config-tab">
          <h4 class="text-center">Configuación</h4>
          <form @submit.prevent="guardar()" autocomplete="off" class="form-horizontal">
            <div class="form-group form-group-sm row">
              <label for="columnas" class="col-sm-3 col-form-label">Número de columnas:</label>
              <div class="col-sm-9">
                <input type="number" min="1" max="4" class="form-control form-control-sm" v-model="form.columnas">
                <small id="ayudaColumnas" class="form-text text-muted">
                  Cantidad de columnas a mostrar en pantalla principal.
                </small>
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label for="columnas" class="col-sm-3 col-form-label">Imagen Alto:</label>
              <div class="col-sm-9">
                <input type="number" step="0.01" class="form-control form-control-sm" v-model="form.imagen_alto">
                <small id="ayudaColumnas" class="form-text text-muted">
                  Establece la altura de la imagen principal de cada producto en pantalla general. (En pixeles)
                </small>
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Visualizar carro:</label>
              <div class="col-sm-9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="carro" v-model="form.carro" :true-value="1" :false-value="0">
                  <label class="custom-control-label text-muted" for="carro">Habilita el carro de compras.</label>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Texto para ver carro:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.carro_texto_ver">
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Texto para agregar carro:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.carro_texto_agregar">
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Texto para comandas:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.comanda_texto">
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Bienvenida:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.bienvenida">
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Categorias:</label>
              <div class="col-sm-9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="categoria" v-model="form.categorias" :true-value="1" :false-value="0">
                  <label class="custom-control-label text-muted" for="categoria">Habilita el menú lateral de categorías.</label>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Restouch:</label>
              <div class="col-sm-9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="restouch" v-model="form.restouch" :true-value="1" :false-value="0">
                  <label class="custom-control-label text-muted" for="restouch">Esta configuración es usada para enviar órdenes desde una mesa.</label>
                </div>
              </div>
            </div>

            <div class="form-group form-group-sm row" v-if="form.restouch == 1">
              <label class="col-sm-3 col-form-label">Usuario:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.restouch_usuario" placeholder="Usuario en Restouch">
              </div>
            </div>

            <div class="form-group form-group-sm row" v-if="form.restouch == 1">
              <label class="col-sm-3 col-form-label">Contraseña:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.restouch_clave" placeholder="Contraseña en Restouch">
              </div>
            </div>

            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Habilitar envíos:</label>
              <div class="col-sm-9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="webhook" v-model="form.webhook" :true-value="1" :false-value="0">
                  <label class="custom-control-label text-muted" for="webhook">Webhook para enviar pedidos a Restouch o a terceros.</label>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.webhook == 1">
              <label class="col-sm-3 col-form-label">Enlace de envío:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.webhook_url">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.webhook == 1">
              <label class="col-sm-3 col-form-label">Método de envío:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.webhook_metodo">
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Agregado Rápido:</label>
              <div class="col-sm-9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="agregado_rapido" v-model="form.agregado_rapido" :true-value="1" :false-value="0">
                  <label class="custom-control-label text-muted" for="agregado_rapido">Muestra el formulario de agregar producto al carro u orden en la vista general de productos.</label>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm row">
              <label class="col-sm-3 col-form-label">Logotipo:</label>
              <div class="col-sm-9">
                <input type="file" @change="inputLogo" class="form-control-file" accept="image/*">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1">
              <label class="col-sm-3 col-form-label">Bazar publicidad:</label>
              <div class="col-sm-9">
                <input type="file" @change="bazarPublicidad" class="form-control-file" accept="image/*">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1">
              <label class="col-sm-3 col-form-label">Bazar Login:</label>
              <div class="col-sm-9">
                <input type="file" @change="bazarLogin" class="form-control-file" accept="image/*">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1">
              <label class="col-sm-3 col-form-label">Bazar texto:</label>
              <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" v-model="form.bazar_texto">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1">
              <label class="col-sm-3 col-form-label">Bazar modo:</label>
              <div class="col-sm-9">
                <select id="selectBazarModo" class="custom-select" v-model="form.bazar_modo_id">
                  <option :value="m.id" v-for="m in catalogo.bazar_modo" :key="m.id">{{m.descripcion}}</option>
                </select>
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1 && form.bazar_modo_id == 1">
              <label class="col-sm-3 col-form-label">Fecha inicio:</label>
              <div class="col-sm-9">
                <input type="date" class="form-control" v-model="form.bazar_inicio">
              </div>
            </div>
            <div class="form-group form-group-sm row" v-if="form.bazar == 1 && form.bazar_modo_id == 1">
              <label class="col-sm-3 col-form-label">Fecha fin:</label>
              <div class="col-sm-9">
                <input type="date" class="form-control" v-model="form.bazar_fin">
              </div>
            </div>
            <div class="form-group form-group-sm row mb-1">
              <div class="col-sm-12 text-right">
                <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="btnGuardar"
                  ></span>
                  <span class="sr-only" v-if="btnGuardar">Guardando...</span>
                  <span v-else>Guardar</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="tab-pane fade" id="nav-redes" role="tabpanel" aria-labelledby="nav-redes-tab" v-if="reg != '' && form.bazar == 1">
          <ManteBazarRedes></ManteBazarRedes>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import CartaCatalogo from '../mixins/CartaCatalogo.js';
  import ManteAccion from '../mixins/ManteAccion.js';
  import ManteBazarRedes from './ManteBazarRedes.vue';

  export default {
    name: 'ManteConfiguracion',
    mixins: [ManteAccion, CartaCatalogo],
    data: () => {
      return {
        reg: '',
        form: {restouch:0, webhook:0},
        btnGuardar: false
      }
    },
    created () {
      this.buscar();
      this.nombre = 'configuracion';
      this.getCatalogo(["bazar_modo"])
    },
    methods: {
      buscar () {
        axios
        .get(this.UrlBase+'/catalogo/get_configuracion')
        .then(res => {
          if (res.data.config) {
            this.form = res.data.config;
            this.reg = res.data.reg;
          } else {
            this.form = {};
          }
        }).catch(e => {
          alert('Configuración '+e);
        });
      },
      guardar () {
        this.btnGuardar = true;
        let datos = new FormData();

        for (const key in this.form) {
          if (this.form[key] !== null) {
            datos.append(key, this.form[key]); 
          }
        }

        axios
        .post(this.UrlBase+'/mante/set_configuracion/'+this.reg, datos)
        .then(r => {
          if (r.data.exito) {
            this.showSuccessMsg({message: r.data.mensaje});
            this.form = r.data.registro;
          } else {
            this.showWarnMsg({message: r.data.mensaje});
          }
          this.btnGuardar = false;
        })
        .catch(e => {
          this.showErrorMsg({message: e});
          this.btnGuardar = false;
        });
      },
      inputLogo(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.form.logo = files[0];
      },
      bazarPublicidad (e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.form.bazar_publicidad = files[0];
      },
      bazarLogin (e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.form.bazar_login = files[0];
      }
    },
    components: {
      ManteBazarRedes
    }
  }
</script>